var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMazakM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.5 138.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5901",
    d: "M 64.058,49.597 L 32.397,0.141 L 0.036,0.141 L 0.0,138.415 L 25.713,138.415 L 25.742,38.17299999999999 L 42.695,62.97399999999999 C 53.238,77.788 72.78,63.217 64.058,49.597 M 138.76,0.0 L 106.399,0.0 L 74.739,49.451 C 66.021,63.076 85.558,77.643 96.104,62.828 L 113.05799999999999,38.036 L 113.08999999999999,138.41500000000002 L 138.797,138.41500000000002 L 138.76,0.0 M 56.626,83.149 L 56.564,138.415 L 81.71000000000001,138.415 L 81.745,83.149 L 81.828,83.149 C 80.583,65.013 56.306,66.975 56.626,83.149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMazakM);
export default __webpack_public_path__ + "static/media/mazak-m.85c6ecb71a57a27a33639ac66daab19b.svg";
export { ForwardRef as ReactComponent };